import { createReducer, on } from '@ngrx/store';

import { TicketListFilter } from '@main-application/tickets/config/interfaces/ticket-list-filter';
import {
  clearTicketStore,
  getPropertyTicketList,
  getPropertyTicketListFailed,
  getPropertyTicketListSuccess,
  getTicketList,
  getTicketListFailed,
  getTicketListSuccess,
  markTicketAsDone,
  markTicketAsDoneFailed,
  markTicketAsDoneSuccess,
  setTicketListFilter,
} from '@main-application/tickets/store/actions/tickets.actions';
import { RestTicketModel } from '@shared/interfaces/turnover.interface';

export const ticketsFeatureKey = 'tickets';

export interface State {
  ticketList: RestTicketModel[];
  ticketListLoading: boolean;
  ticketListFilter: TicketListFilter;
  updatedTicket: RestTicketModel;
  updatedTicketLoading: boolean;
}

export const initialState: State = {
  ticketList: [],
  ticketListLoading: false,
  ticketListFilter: {},
  updatedTicket: null,
  updatedTicketLoading: false,
};

export const reducer = createReducer(
  initialState,
  /**
   * Get ticket list
   */
  on(getTicketList, (state, action) => ({
    ...state,
    ticketListLoading: true,
  })),
  on(getTicketListSuccess, (state, action) => ({
    ...state,
    ticketListLoading: false,
    ticketList: action.ticketList,
  })),
  on(getTicketListFailed, (state, action) => ({
    ...state,
    ticketListLoading: false,
    ticketList: [],
  })),

  /**
   * get property ticket list
   */
  on(getPropertyTicketList, (state, action) => ({
    ...state,
    ticketListLoading: true,
  })),
  on(getPropertyTicketListSuccess, (state, action) => ({
    ...state,
    ticketListLoading: false,
    ticketList: action.ticketList,
  })),
  on(getPropertyTicketListFailed, (state, action) => ({
    ...state,
    ticketListLoading: false,
    ticketList: [],
  })),

  /**
   * mark ticket as done
   */
  on(markTicketAsDone, (state, action) => ({
    ...state,
    updatedTicketLoading: true,
  })),
  on(markTicketAsDoneSuccess, (state, action) => ({
    ...state,
    updatedTicketLoading: false,
    updatedTicket: action.updatedTicket,
  })),
  on(markTicketAsDoneFailed, (state, action) => ({
    ...state,
    updatedTicketLoading: false,
    updatedTicket: null,
  })),

  /**
   * set ticket list filter
   */
  on(setTicketListFilter, (state, action) => ({
    ...state,
    ticketListFilter: action.ticketListFilter,
  })),

  /**
   * clear Ticket Store
   */
  on(clearTicketStore, (state, action) => ({
    ...state,
    ...initialState,
  }))
);
